import styled from "styled-components";
import { InputText } from "primereact/inputtext";
import { Colors } from "../../constants/Colors";
import { Dropdown } from "primereact/dropdown";
import { Modal } from "@vds/modals";

export const CustomizedModal = styled(Modal)`
  padding: ${(props) => (props.desktop ? "1.5rem 0 0!important" : "0px 0px 0px 0px")};
`;

export const AddContactWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: ${(props) => {
    let widthValue;
    if (props.desktop && props.width) {
      widthValue = props.width;
    } else if (props.desktop) {
      widthValue = "60%";
    } else {
      widthValue = "100%";
    }
    return widthValue;
  }};
  font-family: "neue-haas-grotesk-text";
  padding: ${(props) => {
    if (props.desktop) {
      return props.footerWrapper ? "12px 10px 10px 10px" : "48px 10px 10px 10px";
    }
    return props.footerWrapper ? "16px 20px 0px 20px" : "24px 20px 20px 20px";
  }};
  margin: ${(props) => {
    let marginValue;
    if (props.desktop) {
      if (props.footerWrapper && (props.regionId === "840" || props.regionId === "124")) {
        marginValue = "0px auto 70px auto";
      } else {
        marginValue = "0px auto";
      }
    } else if (props.footerWrapper && (props.regionId === "840" || props.regionId === "124")) {
      marginValue = "0px 10px 65px 0px";
    } else {
      marginValue = "0px auto";
    }
    return marginValue;
  }};
  @media (max-width: 400px) {
    justify-content: ${(props) => (!props.footerWrapper ? "flex-start" : "center")};
    height: ${(props) => props?.height ?? ""};
    overflow-y: ${(props) => !props.footerWrapper && "scroll"};
  }
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.desktop ? "row" : "column")};
  gap: ${(props) => (props.desktop ? "24px" : "12px")};
  padding: ${(props) => (props.desktop ? "0px 0px 24px 0px" : "0px 0px 12px 0px")};
`;

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-weight: 700;
  font-size: 12px;
  width: ${(props) => (props.desktop ? "50%" : "100%")};
`;

export const FormTitle = styled.div`
  font-family: neue-haas-grotesk-text;
  font-weight: 700;
  font-size: ${(props) => (props.desktop ? "40px" : "24px")};
  & h3 {
    font-family: neue-haas-grotesk-display;
    font-weight: 700;
    line-height: ${(props) => (props.desktop ? "2rem" : "20px")};
    text-align: left;
    padding: ${(props) => (props.desktop ? " 0px 0px 24px 0px" : " 0px 0px 0px 0px")};
    margin-top: 48px;
    @media (max-width: 679px) {
      margin-top: 24px;
    }
  }
`;

export const SubNavigationTitle = styled.div`
  & h3 {
    font-family: neue-haas-grotesk-text !important;
    font-weight: 700 !important;
    font-size: ${(props) => (props.desktop ? "24px" : "20px")} !important;
    line-height: ${(props) => (props.desktop ? "32px" : "0px")} !important;
    text-align: left;
    margin-top: 0;
  }
`;

export const LabelContainer = styled.div`
  font-family: neue-haas-grotesk-text;
  font-size: ${(props) => (props.desktop ? "14px" : "12px")};
  text-align: left;
  margin: ${(props) => (props.desktop ? "10px 0px 15px 0px" : "10px 0px 10px 0px")};
  margin-top: ${(props) => (props.notificationText ? "0px !important" : "")};
`;

export const FieldLabelContainer = styled.div`
  font-family: neue-haas-grotesk-text;
  font-size: 12px;
  text-align: left;
  padding: 0px 0px 8px 0px;
  letter-spacing: 0;
`;

export const PhoneContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const CustomisedPrimeInput = styled(InputText)`
  font-family: "neue-haas-grotesk-text" !important;
  color: ${Colors.black};
  width: 100%;
  font-size: 14px;
  padding: 12px 16px 12px 16px;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid
    ${(props) => {
      let borderColor;
      if (props.required) {
        borderColor = `${Colors.error} !important`;
      } else if (props.validGreen) {
        borderColor = `${Colors.validInput} !important`;
      } else {
        borderColor = `${Colors.grayBorder} !important`;
      }
      return borderColor;
    }};
  :hover {
    border: 1px solid ${(props) => (props.required ? `${Colors.error} !important` : `${Colors.activeDefault} !important`)};
  }
  :enabled {
    :focus {
      border: 1px solid
        ${(props) => {
          let borderColor;
          if (props.required) {
            borderColor = `${Colors.error} !important`;
          } else if (props.validGreen) {
            borderColor = `${Colors.validInput} !important`;
          } else {
            borderColor = `${Colors.activeDefault} !important`;
          }
          return borderColor;
        }};
      box-shadow: unset;
    }
  }
  :disabled {
    background: ${Colors.foregroundSecondarybackground};
  }
`;

export const StarSpan = styled.span`
  color: ${Colors.activeDefault};
  padding: 0 0 0 4px;
  font-size: 15px;
`;

export const ErrorContainer = styled.div`
  margin: 4px 0 0 0;
  font-family: neue-haas-grotesk-text;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  color: ${Colors.error};
`;

export const CustomizedCountrySelect = styled(Dropdown)`
  height: 42px;
  width: ${(props) => (props.customWidth ? "74px" : "30%")};
  font-size: 14px;
  font-family: "neue-haas-grotesk-text";
  color: ${Colors.black};
  box-sizing: border-box;
  border: 1px solid ${Colors.grayBorder} !important;
  border-radius: 4px 0 0 4px;
  &:disabled {
    background: ${Colors.foregroundSecondarybackground};
  }
  &:focus {
    outline: none;
    border: ${(props) => (props.disabled ? "" : `1px solid ${Colors.activeDefault} !important`)};
  }
  &:hover {
    border: ${(props) => (props.disabled ? "" : `1px solid ${Colors.activeDefault} !important`)};
    border-radius: ${(props) => (props.disabled ? "" : "4px")};
  }
  &::placeholder {
    color: ${Colors.black};
    font-size: 0.875rem;
  }
  .p-dropdown-trigger {
    width: 25px !important;
  }
  .p-dropdown-label {
    font-size: 14px;
    font-family: "neue-haas-grotesk-text";
    color: ${Colors.black};
    padding: 10px 0px 0px 5px;
  }
`;

export const CustomisedPhoneInput = styled(InputText)`
  box-sizing: border-box;
  border: ${(props) => {
    let borderColor;
    if (props.phoneNumberDefault) {
      borderColor = `1px solid ${Colors.grayBorder} !important`;
    } else if (props.validPhoneNumber) {
      borderColor = `1px solid ${Colors.validInput} !important`;
    } else {
      borderColor = `1px solid ${Colors.error} !important`;
    }
    return borderColor;
  }};
  border-radius: 0 4px 4px 0;
  font-size: 14px;
  font-family: "neue-haas-grotesk-text";
  color: ${Colors.black};
  width: ${(props) => (props.customWidth ? "281px" : "70%")};
  height: 42px;
  padding-left: 7px;
  &:disabled {
    background: ${Colors.foregroundSecondarybackground};
    opacity: 0.6;
  }
  :enabled {
    :focus {
      box-shadow: unset;
    }
  }
  &:focus {
    outline: none;
    border: ${(props) => {
      if (props.disabled) {
        return "";
      }
      let borderColor;
      if (props.phoneNumberDefault) {
        borderColor = `1px solid ${Colors.activeDefault} !important`;
      } else if (props.validPhoneNumber) {
        borderColor = `1px solid ${Colors.validInput} !important`;
      } else {
        borderColor = `1px solid ${Colors.error} !important`;
      }
      return borderColor;
    }};
  }
  &:hover:not(:focus) {
    border: ${(props) => (props.disabled ? "" : `1px solid ${Colors.activeDefault} !important`)};
    border-radius: ${(props) => (props.disabled ? "" : "4px")};
  }
  &::placeholder {
    color: ${Colors.foregroundSecondaryText};
    font-size: 14px;
    font-family: "neue-haas-grotesk-text";
    font-weight: 400;
    line-height: 20px;
  }
`;

export const CustomHeader = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0px 0px 12px 0px;
  // padding: 10px 10px 10px 10px;
`;

export const CustomFooter = styled.footer`
  display: flex;
  flex-direction: row;
  margin: ${(props) => (props.desktop ? "5px 300px 0px 0px" : "5px 0px 70px 0px")};
  justify-content: ${(props) => (props.desktop ? "flex-end" : "center")};
`;

export const CustomisedBackPath = styled.img`
  width: 36px;
  height: 24px;
  margin: 5px 24px 0px 24px;
  cursor: pointer;
`;

export const CustomizedLine = styled.hr`
  width: 107%;
  background-color: #d8dada;
  height: 1px;
  margin-bottom: 0px;
  margin-top: ${(props) => {
    let marginTop;
    if (props.lineForFooter) {
      marginTop = props.desktop ? "100px" : "0px";
    } else {
      marginTop = "0px";
    }
    return marginTop;
  }};
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: ${(props) => {
    let widthValue;
    if (props.desktop) {
      widthValue = props.windowSize > 1200 ? "100%" : "80%";
    } else {
      widthValue = "100%";
    }
    return widthValue;
  }};
  // padding: ${(props) => (props.desktop ? "0px 0px 0px 0px" : "0px 0px 16px 0px")};
  justify-content: ${(props) => (props.desktop ? "flex-end" : "center")};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  font-weight: 700;
  font-size: 12px;
  ${(props) => !props.desktop && "width: " + "50%"};
`;

export const AddContactInfoWrapper = styled.div`
  font-family: neue-haas-grotesk-text;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  padding: ${(props) => (props.ismobile ? "12px 0 0 0 " : "0px")};
  letter-spacing: 0;
`;

export const AddcontactFooter = styled.div`
  position: absolute;
  width: ${(props) => (props) => props.windowSize > 1400 ? "98%" : "100%"};
  bottom: 0;
  @media (max-width: 679px) {
    position: absolute;
    bottom: 0;
    background-color: white;
    padding-bottom: 20px;
  }
`;

export const MandatoryFieldsContainer = styled.div`
  font-family: neue-haas-grotesk-text;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  width: ${(props) => (props.desktop ? "80%" : "100%")};
  padding: ${(props) => (props.desktop ? "0px 0px 24px 0px" : "0px 0px 12px 0px")};
  letter-spacing: 0;
`;

export const FooterButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
  margin: 0.75rem 0 0 0;
  width: ${(props) => (props.width ? props.width : "80%")};
  @media (min-width: 768px) {
    padding-right: 2.2em;
  }
  @media (min-width: 1024px) {
    padding-right: 1em;
  }
`;
